<template>
    <div class="flex flex-row h-full justify-end" >     
        <div class="w-8 h-8 pt-0.5 flex justify-center items-center">
            <SearchSVG
                fill="#4a5565" 
            />
        </div>
        <input class="p-1 w-full focus:outline-none bg-inherit"
            type="text" 
            :placeholder="placeholder" 
            v-model="quickSearchFilter"
        />
        <div class="w-8 h-8 flex justify-center items-center absolute">
            <button
                v-if="quickSearchFilter"
                class="w-6 h-6 bg-inherit flex justify-center items-center absolute right-[3px] top-[3px] rounded-sm hover:bg-gray-200 cursor-pointer"
                @click="clearQuickSearchFilter"
                @mouseover="highlightQuickSearchStroke"
                @mouseout="unhiglightQuickSearchStroke"
            >
                <XMarkSVG
                    :stroke="quickSearchStroke"
                    width="3"
                />
            </button>
        </div> 
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import XMarkSVG from '../svg-components/XMarkSVG.vue';
  import SearchSVG from "../svg-components/SearchSVG.vue";
// placeholder="&#9906;" 

const props = defineProps(['placeholder'])
const emit = defineEmits(['quick-search', 'clear-quick-search'])

const quickSearchFilter = ref(null);
const quickSearchStroke = ref('#3F3F46');

watch(quickSearchFilter, () => {
emit('quick-search', quickSearchFilter.value)
})

function highlightQuickSearchStroke() {
quickSearchStroke.value = '#464866'
}

function unhiglightQuickSearchStroke() {
quickSearchStroke.value = '#3F3F46'
}

function clearQuickSearchFilter() {
  quickSearchFilter.value = null
  emit('clear-quick-search')
}

</script>

<!-- <style scoped>
  input::placeholder {
    width: fit-content;
    height: fit-content;
    position: absolute;
    top: -2px;
    left: 4px;
    font-size: 22px;
    -webkit-transform: rotate(-45deg); 
               -moz-transform: rotate(-45deg); 
                 -o-transform: rotate(-45deg);
                    transform: rotate(-45deg);
  }
</style> -->